import ResultsClientWithKeycloak from '../common/ResultsClientWithKeycloak';
import { HTTP_METHOD } from '../common/consts';

export class OLResultsClientWithKeycloak extends ResultsClientWithKeycloak {
    static BASE_URL = '/ol-api/results/v1/results';

    getRequestHeaders = (token = '', staffId = '') => ({
        ...(token && { authorization: `Bearer ${token}` }),
        ...(staffId && { staff: staffId }),
    });

    /**
     * Get http client config for get results operation
     * @param {Object{}} params get request parameters
     * @param {String} token - keycloak token for API authorization
     * @param {String} staffId - staffId for an additional header used in results caching.
     * @returns {Object}
     */

    static getResultsRequestConfig(
        { studentUids, schoolYear, includeInvalidated, language, classId } = {},
        token = '',
        staffId = '',
    ) {
        const headers = this.getRequestHeaders(token, staffId);

        return {
            url: this.BASE_URL,
            method: HTTP_METHOD.GET,
            headers,
            params: {
                studentUids: studentUids.join(','),
                schoolYear,
                includeInvalidated,
                language: language && language.join(','),
                classId,
            },
        };
    }

    /**
     * Send request to get result on server from provided data
     * @param {Array<String>} studentUids - non-empty list of student ids to get results for
     * @param {Integer} schoolYear - school year to get results for, optional
     * @param classId
     * @param instId
     * @param {Array<String>} [language=[]] - results' language, e.g. ['eng', 'spa']
     * @param {String} token - keycloak token for API authorization
     * @param {String} staffId - staffId for an additional header used in results caching.
     */

    async getResults(studentUids, schoolYear, classId, instId, token = '', staffId = '', language) {
        const includeInvalidated = false;
        return this.httpClient.request(
            this.constructor.getResultsRequestConfig(
                {
                    studentUids,
                    schoolYear,
                    includeInvalidated,
                    language,
                    classId,
                },
                token,
                staffId,
            ),
        );
    }
}

export default OLResultsClientWithKeycloak;
